import { Children, ComponentProps, FC, PropsWithChildren } from 'react';
import { LinearProgress, MenuItem, Select, Stack } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

type Props = ComponentProps<typeof Select<string>> &
	Readonly<{
		loading?: boolean;
		noItemsText?: string;
	}>;

const LoadableSelect: FC<PropsWithChildren<Props>> = ({ loading, children, disabled, value, noItemsText, ...props }) => {
	const intl = useIntl();

	return (
		<Stack sx={{ position: 'relative', width: '100%' }}>
			<Select
				{...props}
				value={loading ? 'loading' : value}
				disabled={loading || disabled}
				MenuProps={{ slotProps: { paper: { sx: { maxHeight: 500 } } } }}
			>
				{children}
				{loading === true && (
					<MenuItem value={'loading'} disabled>
						<FormattedMessage id={'common.loading'} />
					</MenuItem>
				)}
				{loading !== true && Children.count(children) === 0 && (
					<MenuItem value={'no-items'} disabled>
						<em>{noItemsText ?? intl.formatMessage({ id: 'common.no-items' })}</em>
					</MenuItem>
				)}
			</Select>
			{loading === true && (
				<LinearProgress
					sx={{
						position: 'absolute',
						bottom: 0,
						width: '100%',
						height: 4,
						borderTopRightRadius: 0,
						borderTopLeftRadius: 0,
					}}
				/>
			)}
		</Stack>
	);
};

export { LoadableSelect };
